import React from 'react'
import {Accordion, Container} from "react-bootstrap";

const EstandarSoftware = () => {

    const data = [
        {
            category: 'Sistemas operativos e interfaces gráficas',
            platforms: [
                'AIX Versión 7.1 TL5 o superior',
                'Oracle Solaris',
                'Linux (Red Hat, SuSe, Oracle)',
                'Microsoft Windows 10 Profesional 64 bits',
                'Microsoft Windows Server 2019 Estándar',
                'MacOs Catalina',
            ],
        },
        {
            category: 'Plataformas para ambientes virtuales',
            platforms: ['IBM PowerVM', 'Microsoft Windows Server Hypher-V', 'Vmware Vsphere ESXi', 'Oracle VM'],
        },
        {
            category: 'Plataformas para virtualización de aplicaciones y escritorios remotos',
            platforms: ['Citrix', 'Microsoft Remote Desktop', 'Vmware'],
        },
        {
            category: 'Plataformas de bases de datos',
            platforms: ['Oracle 11g R2', 'DB2/Informix', 'Microsoft SQL Server 2017'],
        },
        {
            category: 'Plataformas para desarrollo de software',
            platforms: [
                'Power Builder, .NET Framework 4.6.1 o superior',
                'Java 1.8 o superior',
                'Oracle forms',
                'Android native 21+',
                'IOS SDK 11 o superior',
                'Oracle report runtime',
                'Xamarin',
            ],
        },
        {
            category: 'Plataformas para respaldos de información',
            platforms: ['VEEAM backup', 'IBM Spectrum', 'Veritas'],
        },
        {
            category: 'Ofimática',
            platforms: [
                'Microsoft Office 2019',
                'Microsoft Office 365 Empresarial y Corporativo',
                'Microsoft Visio Profesional 2019 (Licencia local o Empresarial y Corporativo)',
            ],
        },
        {
            category: 'Correo Electrónico',
            platforms: ['Microsoft Office 365 Empresarial y Corporativo', 'Google G-Suite Empresarial y Corporativo'],
        },
        {
            category: 'Control de proyectos',
            platforms: ['Microsoft Project 2019 (Licencia local o Empresarial y Corporativo)'],
        },
        {
            category: 'Diseño Gráfico y Fotocomposición',
            platforms: ['Corel Draw Suite 2019', 'Adobe Creative Cloud', 'AutoDesk (AutoCAD)'],
        },
        {
            category: 'Multimedia',
            platforms: ['Adobe Creative Cloud'],
        },
        {
            category: 'Internet',
            platforms: ['Adobe Creative Cloud', 'SWiSH Max 4', 'Javascript'],
        },
        {
            category: 'Firma Electrónica',
            platforms: ['SeguriServer', 'SeguriSign', 'SeguriNotary'],
        },
    ];

    // Función que crea un objeto Accordion único para cada elemento en el arreglo `data`
    function GenerateUniqueAccordions() {
        return data.map((item, index) => (
            <>
                <hr style={{  borderColor:'#eeeeee' }}/>
                <Accordion defaultActiveKey="0" key={index}>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header><h2>{item.category.toUpperCase()}</h2></Accordion.Header>
                        <Accordion.Body>
                            <div>
                                <h6><strong>Válido a partir del 14 de Agosto de 2023</strong></h6>
                                <h6>
                                    <strong>Estatus:&nbsp;</strong>Vigente &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                </h6>
                                <h6><strong>Categoría:&nbsp;</strong>Estándares Técnicos de Software</h6>
                                <table className="table table-striped table-bordered">
                                    <tbody>
                                    <tr>
                                        <td>SOFTWARE</td>
                                        <td>
                                            <ul>
                                                {item.platforms.map((platform, i) => (
                                                    <li key={i}>{platform}</li>
                                                ))}
                                            </ul>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </>



        ));
    }

    return (
      <Container className="custom-accordion">
        <hr style={{  borderColor:'#eeeeee' }}/>

        <Container>
            <div>
                <h2 className="encabezadoEstandar">ESTÁNDARES TÉCNICOS DE SOFTWARE</h2>
                <h3>Todo software que no figure en la siguiente lista debe ser dictaminado</h3>
            </div>
        </Container>



        <hr style={{  borderColor:'#eeeeee' }}/>
        <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="1">
                <Accordion.Header><h2>ANTIVIRUS</h2></Accordion.Header>
                <Accordion.Body>
                    <div>
                        <h6><strong>Válido a partir del 14 de Agosto de 2023</strong></h6>

                        <h6><strong>Estatus:&nbsp;</strong>Vigente &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</h6>

                        <h6><strong>Categoría:</strong> Estándares Técnicos de Software</h6>

                        <h6>
                            
                        </h6>

                        <table className="table table-striped table-bordered">
                            <tbody>
                            <tr>
                                <td >No.
                                    
                                </td>
                                <td >
                                    <strong>COMPONENTE</strong>
                                    
                                </td>
                                <td >
                                    <strong>CARACTERISTICA</strong></td>
                            </tr>
                            <tr>
                                <td >1</td>
                                <td  ><strong>Versión</strong></td>
                                <td  >La más reciente al momento de su
                                    adquisición,o actualización de licenciamiento para:
                                    -Particulares (Oficina)
                                        -Empresarial (pequeña o mediana)
                                            -Corporativo
                                                
                                </td>
                            </tr>
                            <tr>
                                <td >2</td>
                                <td  ><strong>Tipo de seguridad,
                                    protección, prevención, detección, gestión y respuesta</strong></td>
                                <td  >Los antivirus deben de proveer alguna
                                    de los siguientes servicios indicados, esto de acuerdo a la necesidad del Ente:
                                    -Seguridad para la Nube, Nube Hibrida, Redes e Internet
                                        -Protección de &nbsp;Usuarios, Software.
                                            -Protección en endpoints, hosting, housing, datacenters, servidores,
                                                workloads en la nube, Correos electrónicos, Información, Datos.
                                                -Detección, respuesta, prevención y protección &nbsp;de amenazas
                                                    comunes y avanzadas
                                                    -Gestión de vulnerabilidades
                                                        
                                </td>
                            </tr>
                            <tr>
                                <td >3</td>
                                <td  ><strong>Sistemas operativos
                                    compatibles&nbsp;</strong></td>
                                <td  >Puede ser para alguna de las
                                    siguiente:
                                    GNU/Linux, Windows, Mac OS X, Android o iOS, indicar si es para otro tipo de
                                        Sistema Operativo</td>
                            </tr>
                            <tr>
                                <td >4</td>
                                <td  ><strong>Soporte y Servicios</strong>
                                </td>
                                <td  >Opcional, si el Ente lo requiere.
                                    -Soporte de Asesoramiento
                                        -Servicio de asistencia 24/7</td>
                            </tr>
                            <tr>
                                <td >5</td>
                                <td  ><strong>Recursos de computo</strong>
                                </td>
                                <td  >Garantizar que los recursos
                                    disponibles sea suficientes para su instalación, para asegurar la eficacia,
                                    usabilidad y soluciones del software de protección.&nbsp;</td>
                            </tr>
                            <tr>
                                <td >6</td>
                                <td  ><strong>Fabricantes&nbsp;</strong>
                                </td>
                                <td  >Pueden ser alguna de los siguientes
                                    fabricantes:
                                    
                                        -BITDEFENDER
                                            -BROADCOM (SYMANTEC)
                                                -ESET
                                                    -KASPERSKY
                                                        -McAfee
                                                            -TREND MICRO
                                                                -WITHSECURE (F-SECURE)
                                                                    
                                                                        Otros fabricantes deben ser dictaminados
                                </td>
                            </tr>
                            <tr>
                                <td >7</td>
                                <td  ><strong>Consola</strong></td>
                                <td  >Opcional: Consola de administración
                                    de antivirus
                                    Especificar número de usuarios y equipos que serán administrados mediante
                                        consola.&nbsp;</td>
                            </tr>
                            <tr>
                                <td >8</td>
                                <td  ><strong>Software</strong></td>
                                <td  >
                                    <ul>
                                        <li>Antivirus (Corporativo)</li>
                                        <li>Symantec Norton Antivirus (Corporativo)</li>
                                        <li>McAfee Antivirus (Corporativo)</li>
                                        <li>ESET Antivirus (Corporativo)</li>
                                    </ul>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>

        <hr style={{  borderColor:'#eeeeee' }}/>
        <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="1">
                <Accordion.Header><h2>SERVIDORES WEB Y APP</h2></Accordion.Header>
                <Accordion.Body>
                    <div>
                        <h6><strong>Válido a partir del 14 de Agosto de 2023</strong></h6>

                        <h6>
                            <strong>Estatus:&nbsp;</strong>Vigente &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        </h6>

                        <h6><strong>Categoría:</strong> Estándares Técnicos de
                            Software &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</h6>

                        <ul>
                            <li><strong>Apache HTTP Server&nbsp;</strong>V 2.4.54 o superior (<span>&nbsp;</span>
                                <a
                                    href="https://httpd.apache.org/download.cgi">https://httpd.apache.org/download.cgi</a> )
                            </li>
                            <li><strong>Lighthttpd</strong> V 1.4.68 o superior (<span>&nbsp;</span>
                                <a
                                    href="https://www.lighttpd.net/download/">https://www.lighttpd.net/download/</a>)
                            </li>
                            <li><strong>Apache Tomcat</strong><span>&nbsp;</span>V 8.5.50 o
                                superior <span>&nbsp;</span> (
                               <a
                                    href="https://tomcat.apache.org/download-80.cgi">https://tomcat.apache.org/download-80.cgi</a>
                             )
                            </li>
                            <li><strong>Ubuntu&nbsp;</strong>22.04 LTS Server Edition o superior<span>&nbsp;</span>(
                                <a
                                    href="https://ubuntu.com/download/server">https://ubuntu.com/download/server</a>)
                            </li>
                        </ul>
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>


        <hr style={{  borderColor:'#eeeeee' }}/>
        <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="1">
                <Accordion.Header><h2>MANEJO DE IMÁGENES</h2></Accordion.Header>
                <Accordion.Body>
                    <div>
                        <h6><strong>Válido a partir del 14 de Agosto de 2023</strong></h6>

                        <h6>
                            <strong>Estatus:&nbsp;</strong>Vigente &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        </h6>

                        <h6><strong>Categoría:&nbsp;</strong>Estándares Técnicos de Software</h6>

                        <ul>
                            <li>GIMP V 2.10.14 o superior (Programa de Manipulación de Imágenes de GNU -
                               <a
                                    href="https://www.gimp.org/downloads/">https://www.gimp.org/downloads/</a><span>&nbsp;</span>)
                            </li>
                            <li>Blender &nbsp;V 2.81 (Programa multi plataforma, dedicado especialmente
                                al &nbsp;modelado, &nbsp;iluminación, renderizado, animación y creación de
                                gráficos &nbsp; tridimensionales.
                                <a
                                    href="https://www.blender.org/download/">https://www.blender.org/download/</a><span>&nbsp;</span>)
                            </li>
                        </ul>

                        <h6><strong>NOTA: Todos los productos de Adobe y otros &nbsp;no gratuitos requieren dictamen de
                            la ADBC.</strong></h6>
                    </div>

                </Accordion.Body>
            </Accordion.Item>
        </Accordion>


        <hr style={{  borderColor:'#eeeeee' }}/>
        <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="1">
                <Accordion.Header><h2>SOFTWARE DE VIDEOCONFERENCIAS</h2></Accordion.Header>
                <Accordion.Body>

                    <div>
                        <h6><strong>Válido a partir del 14 de Agosto de 2023</strong></h6>

                        <h6>
                            <strong>Estatus:&nbsp;</strong>Vigente &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        </h6>

                        <h6><strong>Categoría:&nbsp;</strong>Estándares Técnicos de Software</h6>

                        <table className="table table-striped table-bordered">
                            <tbody>
                            <tr>
                                <td >
                                    <strong>CARACTERÍSTICAS</strong></td>
                                <td >
                                    <strong>FABRICANTES</strong></td>
                                <td>
                                    
                                </td>
                            </tr>
                            <tr>
                                <td >
                                    <li>100 participantes mínimo.</li>
                                        <li>Número de reuniones ilimitadas.</li>
                                            <li>Grabación local y/o en nube, planificación de reuniones, tiempo en sala</li>
                                                <li>Ilimitada.</li>
                                                </td>
                                <td  >
                                    <li>G-MEET</li>
                                    <li>WEBEX</li>
                                </td>
                                <td>
                                    
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>

        <hr style={{  borderColor:'#eeeeee' }}/>

                   <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="1">
                  <Accordion.Header><h2>SOFTWARE DE APLICACIÓN ESPECIFICA</h2></Accordion.Header>
                  <Accordion.Body>

                      <div>
                          <h6><strong>Válido a partir del 14 de Agosto de 2023</strong></h6>

                          <h6>
                              <strong>Estatus:&nbsp;</strong>Vigente &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          </h6>

                          <h6><strong>Categoría:&nbsp;</strong>Estándares Técnicos de Software</h6>



                          <table className="table table-striped table-bordered">
                              <tbody>
                              <tr>
                                  <td><strong>CATEGORÍA</strong></td>
                                  <td><strong>PLATAFORMAS / SOFTWARE</strong></td>
                              </tr>
                              <tr>
                                  <td>Sistemas operativos e interfaces gráficas</td>
                                  <td>
                                      <ul>
                                          <li>AIX Versión 7.1 TL5 o superior</li>
                                          <li>Oracle Solaris</li>
                                          <li>Linux (Red Hat, SuSe, Oracle)</li>
                                          <li>Microsoft Windows 10 Profesional 64 bits</li>
                                          <li>Microsoft Windows Server 2019 Estándar</li>
                                          <li>MacOs Catalina</li>
                                      </ul>
                                  </td>
                              </tr>
                              <tr>
                                  <td>Plataformas para ambientes virtuales</td>
                                  <td>
                                      <ul>
                                          <li>IBM PowerVM</li>
                                          <li>Microsoft Windows Server Hypher-V</li>
                                          <li>Vmware Vsphere ESXi</li>
                                          <li>Oracle VM</li>
                                      </ul>
                                  </td>
                              </tr>
                              <tr>
                                  <td>Plataformas para virtualización de aplicaciones y escritorios remotos</td>
                                  <td>
                                      <ul>
                                          <li>Citrix</li>
                                          <li>Microsoft Remote Desktop</li>
                                          <li>Vmware</li>
                                      </ul>
                                  </td>
                              </tr>
                              <tr>
                                  <td>Plataformas de bases de datos</td>
                                  <td>
                                      <ul>
                                          <li>Oracle 11g R2</li>
                                          <li>DB2/Informix</li>
                                          <li>Microsoft SQL Server 2017</li>
                                      </ul>
                                  </td>
                              </tr>
                              <tr>
                                  <td>Plataformas para desarrollo de software</td>
                                  <td>
                                      <ul>
                                          <li>Power Builder, .NET Framework 4.6.1 o superior</li>
                                          <li>Java 1.8 o superior</li>
                                          <li>Oracle forms</li>
                                          <li>Android native 21+</li>
                                          <li>IOS SDK 11 o superior</li>
                                          <li>Oracle report runtime</li>
                                          <li>Xamarin</li>
                                      </ul>
                                  </td>
                              </tr>
                              <tr>
                                  <td>Plataformas para respaldos de información</td>
                                  <td>
                                      <ul>
                                          <li>VEEAM backup</li>
                                          <li>IBM Spectrum</li>
                                          <li>Veritas</li>
                                      </ul>
                                  </td>
                              </tr>
                              <tr>
                                  <td>Ofimática</td>
                                  <td>
                                      <ul>
                                          <li>Microsoft Office 2019</li>
                                          <li>Microsoft Office 365 Empresarial y Corporativo</li>
                                          <li>Microsoft Visio Profesional 2019 (Licencia local o Empresarial y Corporativo)</li>
                                      </ul>
                                  </td>
                              </tr>
                              <tr>
                                  <td>Correo Electrónico</td>
                                  <td>
                                      <ul>
                                          <li>Microsoft Office 365 Empresarial y Corporativo</li>
                                          <li>Google G-Suite Empresarial y Corporativo</li>
                                      </ul>
                                  </td>
                              </tr>
                              <tr>
                                  <td>Control de proyectos</td>
                                  <td>
                                      <ul>
                                          <li>Microsoft Project 2019 (Licencia local o Empresarial y Corporativo)</li>
                                      </ul>
                                  </td>
                              </tr>
                              <tr>
                                  <td>Diseño Gráfico y Fotocomposición</td>
                                  <td>
                                      <ul>
                                          <li>Corel Draw Suite 2019</li>
                                          <li>Adobe Creative Cloud</li>
                                          <li>AutoDesk (AutoCAD)</li>
                                      </ul>
                                  </td>
                              </tr>
                              <tr>
                                  <td>Multimedia</td>
                                  <td>
                                      <ul>
                                          <li>Adobe Creative Cloud</li>
                                      </ul>
                                  </td>
                              </tr>
                              <tr>
                                  <td>Internet</td>
                                  <td>
                                      <ul>
                                          <li>Adobe Creative Cloud</li>
                                          <li>SWiSH Max 4</li>
                                          <li>Javascript</li>
                                      </ul>
                                  </td>
                              </tr>
                              <tr>
                                  <td>Antivirus</td>
                                  <td>
                                      <ul>
                                          <li>Kaspersky Antivirus (Corporativo)</li>
                                          <li>Symantec Norton Antivirus (Corporativo)</li>
                                          <li>McAfee Antivirus (Corporativo)</li>
                                          <li>ESET Antivirus (Corporativo)</li>
                                      </ul>
                                  </td>
                              </tr>
                              <tr>
                                  <td>Firma Electrónica</td>
                                  <td>
                                      <ul>
                                          <li>SeguriServer</li>
                                          <li>SeguriSign</li>
                                          <li>SeguriNotary</li>
                                      </ul>
                                  </td>
                              </tr>
                              </tbody>
                          </table>


                      </div>
                  </Accordion.Body>
              </Accordion.Item>
          </Accordion>


          <hr style={{  borderColor:'#eeeeee' }}/>

          {GenerateUniqueAccordions()}

          <hr style={{  borderColor:'#eeeeee' }}/>

    </Container>
  )
}

export default EstandarSoftware
